// cSpell:ignore normalizr
import { schema } from "normalizr";

export const question = new schema.Entity(
  "questions",
  {},
  { idAttribute: "id" }
);
export const questions = [question];
